import { MouseEvent, useCallback, useContext } from 'react';
import { Button, ConfirmModal, ModalProviderContext } from 'ui';
import { TrashGrayIcon } from 'ui/icons';

interface IssuerOperationArchiveButtonProps {
  id: number;
  entityName: string;
  onArchive: (id: number) => Promise<unknown>;
}

export const IssuerOperationArchiveButton = ({
  id,
  entityName,
  onArchive,
}: IssuerOperationArchiveButtonProps) => {
  const { openModal } = useContext(ModalProviderContext);

  const handleArchive = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();

      openModal(ConfirmModal, {
        title: `Archive ${entityName}?`,
        onConfirm: async () => {
          await onArchive(id);
        },
      });
    },
    [entityName, id, onArchive, openModal],
  );

  return (
    <Button
      type="button"
      icon={TrashGrayIcon}
      variant="secondary"
      className="w-[120px]"
      onClick={handleArchive}
    >
      Archive
    </Button>
  );
};
